import React from "react"

import WPImage, { DISPLAY_MODE } from "./_base/WPImage"

import * as sliderStyles from "../styles/Slider.module.css"

export default function Slider(props) {
  const { content } = props

  const titleNode = content.childNodes.filter(
    node => node.classNames === "slider-title"
  )[0]
  const title = (titleNode && titleNode.innerHTML) || ""

  const textStack = content.childNodes
    .filter(node => node.classNames === "slider-content")
    .map(t => t.text)

  return (
    <>
      <div className={`row justify-content-center ${sliderStyles.wrapper}`}>
        <div className={`col-3 ${sliderStyles.logo}`}>
          <WPImage
            holder={content}
            selector={`slider-visual-assets`}
            mode={DISPLAY_MODE.normal}
            className={sliderStyles.logoImage}
          />
        </div>
        <div className={`col-9 ${sliderStyles.content}`}>
          <h4
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
          {textStack.map((t, idx) => (
            <p key={idx}>{t}</p>
          ))}
        </div>
      </div>
    </>
  )
}
